import { lazy } from 'react';

export const PlayerUpdateDepositsBlockForm = lazy(
  () => import('./PlayerUpdateDepositsBlockForm'),
);
